import { ReactComponent as SidebarToggleIcon } from '../../../../assets/SidebarToggle.svg';
import { useDispatch, useSelector } from 'react-redux'
import classes from './SidebarHeader.module.css'
import { toggle } from '../sidebarSlice';

function SidebarHeader() {
    const sidebarState = useSelector(state => state.sidebar)
    const { texts } = useSelector(state => state.translate)
    const dispatch = useDispatch()
    let sidebarHeader = (
        <div className={classes.SidebarHeader}>
            <div
                className={classes.ToggleButton}
                onClick={() => dispatch(toggle({isOpen: false}))}
            >
                <SidebarToggleIcon className={classes.ToggleIconCollapsed} />
            </div>
            <div className={classes.Title}>{texts.allConversations}</div>
        </div>
    )
    if (!sidebarState.isOpen)(
        sidebarHeader = (
            <div className={classes.SidebarHeaderClosed} onClick={() => dispatch(toggle({isOpen: true}))}>
                <div className={classes.ToggleButton}>
                    <SidebarToggleIcon className={classes.ToggleIconExpanded} />
                </div>
            </div>
        )
    )
    return (
        sidebarHeader
    );
}

export default SidebarHeader;
